import { useTranslations } from '@vocab/react';
import { Spread, Badge, CheckboxStandalone, Box } from 'braid-design-system';

import { ResponsiveText } from '../ResponsiveText';

import translations from './.vocab';

interface Props {
  id: string;
  text: string;
  /**
   * count
   * @description is the facet count for each answer. When `count` is null, it means we are loading facets, or cannot show the value (e.g. when it fails to fetch facets)
   */
  count: number | null;
  isSelected?: boolean;
  disabled?: boolean;
  onSelect: () => void;
  isPreferred?: boolean;
}

export const CheckboxRow = ({
  id,
  text,
  count,
  isSelected = false,
  disabled = false,
  onSelect,
  isPreferred = false,
}: Props) => {
  const { t } = useTranslations(translations);
  const label = `${text}${isPreferred ? '\u00A0*' : ''}`;
  return (
    <Box
      component="label"
      cursor={disabled ? 'default' : 'pointer'}
      aria-label={t('answerText count applications', {
        answerText: label,
        count: count ?? 0,
      })}
    >
      <Spread space="xsmall" alignY="top">
        <ResponsiveText
          size={{ mobile: 'standard', tablet: 'small' }}
          fallbackSize="small"
          align="left"
          icon={
            <CheckboxStandalone
              id={id}
              aria-label={label}
              size="small"
              disabled={disabled}
              checked={isSelected}
              onChange={onSelect}
            />
          }
        >
          {label}
        </ResponsiveText>

        {count !== null ? (
          <Badge tone="neutral" bleedY>
            {t('count', { count })}
          </Badge>
        ) : null}
      </Spread>
    </Box>
  );
};
